


























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ChoiceSelect extends Vue {
  @Prop() choices: any[];
  @Prop() selectedChoice: number;
  @Prop() fieldForRank: number;
  @Emit() selectChoice() { return; }
}
